(function () {
  'use strict';

  angular
    .module('unit.interested.leads')
    .directive('unitInterestedLeads', unitInterestedLeads);

  unitInterestedLeads.$inject = [];

  function unitInterestedLeads() {
    var directive = {
      bindToController: true,
      controller: 'unitInterestedLeadsCtrl',
      controllerAs: 'vm',
      template: require('../unit.interested.leads/unit.interested.leads.html'),
      link: link,
      restrict: 'EA',
      scope: {
        unitId: '=',
      },
    };
    return directive;

    function link(scope, element, attrs) {}
  }
})();
